module.exports = __webpack_public_path__ + "img/test-bg-lg.68e0a2c5.jpg";